module.exports = __webpack_public_path__ + "static/img/header_logo.7eda3e7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/header_logo.jpg
// module id = xELo
// module chunks = 1